var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1473358137_Google_alt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CreateAccountPage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-369.000000, -464.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(334.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1473358137_Google_alt",
    transform: "translate(35.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4158095,8.125 C19.5409524,8.79361905 19.6092857,9.49371429 19.6092857,10.2249048 C19.6093333,15.9375238 15.7848095,20 10.0097143,20 C4.48480952,20 0.00971428571,15.5249048 0.00971428571,10 C0.00971428571,4.47509524 4.48480952,0 10.0097143,0 C12.7099048,0 14.9657619,0.993666667 16.6973333,2.60619048 L13.8780952,5.42509524 L13.8780952,5.41866667 C12.8282857,4.41857143 11.4971429,3.90619048 10.0097143,3.90619048 C6.70985714,3.90619048 4.02857143,6.69366667 4.02857143,9.99385714 C4.02857143,13.293381 6.70980952,16.0875714 10.0097143,16.0875714 C13.0035238,16.0875714 15.0408095,14.3749524 15.4601905,12.0250952 L10.0097143,12.0250952 L10.0097143,8.125 L19.4158095,8.125 L19.4158095,8.125 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3e4a70bcfbe22a30bfc5c8fdfde6d6b0.svg";
export { ForwardRef as ReactComponent };